module.exports = __webpack_public_path__ + "static/nettiterapia2-310x345-7197.28115055.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nettiterapia2-310x345-7197.jpg
// module id = 834
// module chunks = 41163700655044